




































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import ChecklistEntrega from '../../model/resource/ChecklistEntrega'
import {ItrackCollection} from '../../helpers'
import TipoChecklistEntrega from '../../model/resource/TipoChecklistEntrega'

const metaInfo = () => ({
    title: $.t('view.persist.CheckListEntregaPersist.title'),
})

@Component({
    metaInfo,
})
export default class CheckListEntregaPersistView extends Vue {
    @Prop({type: [String, Number]}) id?: ID

    AppConfig = AppConfig
    allType = ItrackCollection.allTipoChecklist

    listToPersist: ChecklistEntrega[] = []

    get editMode() {
        return Boolean(this.id)
    }

    created() {
        this.$set(this.listToPersist, 0,  new ChecklistEntrega())
    }

    async mounted() {
        await this.allType.query()
        if (this.id) await this.listToPersist[0].getChecklistEntrega(this.id)
        $.await.done('getChecklistEntrega')
    }

    addItem() {
        this.listToPersist.push(new ChecklistEntrega())
    }

    removeItem(item: ChecklistEntrega) {
        const index = this.listToPersist.indexOf(item)
        if (index > -1) {
            this.listToPersist.splice(index, 1)
            this.$forceUpdate()
        }
    }

    async persist() {
        await ChecklistEntrega.persistLoteTipoOcorrencia(this.listToPersist)
        successAndPush('system.success.persist', '/manage/checklist-entrega/list')
    }
}
